import { useMemo } from 'react'

import { Box } from '@mui/material'

import { modernTabStyles } from '../../lib/style'
const defaultSx = {}
const BodyContainer = ({ children, sx = defaultSx }) => {
  const containerSx = useMemo(() => {
    return {
      height: '100vh',
      width: 'calc(100%)',
      overflowY: 'hidden',
      overflowX: 'auto',
      mx: '-8px',
      px: '16px',
      background: (theme) => theme.palette.background.default,
      ...modernTabStyles,
      ...sx,
    }
  }, [sx])
  return (
    <Box
      className="body-container"
      sx={containerSx}
    >
      {children}
    </Box>
  )
}

export default BodyContainer
